import { b as bootstrapLazy } from './index-e3eeb4ec.js';
export { s as setNonce } from './index-e3eeb4ec.js';
import { g as globalScripts } from './app-globals-0f993ce5.js';
const defineCustomElements = async (win, options) => {
  if (typeof window === 'undefined') return undefined;
  await globalScripts();
  return bootstrapLazy([["skip-back-btn_2", [[0, "skip-back-btn", {
    "publicAPI": [16]
  }, [[2, "click", "handleClick"]]], [0, "skip-forward-btn", {
    "publicAPI": [16]
  }, [[2, "click", "handleClick"]]]]], ["custom-toggle", [[0, "custom-toggle", {
    "uniqueId": [1, "unique-id"],
    "label": [1],
    "isChecked": [4, "is-checked"]
  }]]], ["relative-date-time", [[0, "relative-date-time", {
    "pubDate": [2, "pub-date"],
    "includeSeconds": [4, "include-seconds"],
    "isLive": [4, "is-live"],
    "relativeDateTime": [32]
  }]]], ["options-menu-back-btn", [[0, "options-menu-back-btn", {
    "publicAPI": [16],
    "menuTitle": [1, "menu-title"]
  }, [[0, "click", "handleClick"]]]]], ["buffer-bar_10", [[0, "seek-bar", {
    "publicAPI": [16],
    "playerStatus": [32],
    "isSeekable": [32],
    "isClientSideAdvertising": [32]
  }], [0, "volume-controls", {
    "publicAPI": [16],
    "sliderVisible": [32]
  }, [[0, "focusin", "handleVolumeVisible"], [1, "mouseover", "handleVolumeVisible"], [0, "focusout", "handleVolumeNotVisible"], [1, "mouseout", "handleVolumeNotVisible"]]], [0, "options-menu", {
    "publicAPI": [16],
    "menuConfig": [16],
    "ctaConfig": [16]
  }, [[0, "click", "handleClick"], [0, "keydown", "handleKeyDown"]]], [0, "currenttime-metadata", {
    "publicAPI": [16],
    "currentTime": [32],
    "isSeekable": [32],
    "duration": [32],
    "isAtLiveEdge": [32],
    "liveSyncPosition": [32]
  }], [0, "duration-metadata", {
    "publicAPI": [16],
    "isSeekable": [32],
    "duration": [32]
  }], [0, "play-pause-stop-btn", {
    "publicAPI": [16],
    "isSeekable": [32],
    "playerStatus": [32],
    "isMediaLoading": [32]
  }, [[0, "click", "handleClick"]]], [0, "buffer-bar", {
    "publicAPI": [16],
    "isSeekable": [32],
    "bufferDataValue": [32],
    "bufferDataMax": [32]
  }], [0, "muted-btn", {
    "publicAPI": [16],
    "isMuted": [32],
    "isNoVolume": [32]
  }, [[0, "click", "handleClick"]]], [0, "seek-input", {
    "publicAPI": [16],
    "timeTooltipValues": [32],
    "currentTime": [32],
    "isSeekable": [32],
    "seekableRangeStart": [32],
    "seekableRangeEnd": [32]
  }], [0, "volume-slider", {
    "visibleByParent": [4, "visible-by-parent"],
    "publicAPI": [16],
    "volume": [32]
  }]]], ["captions-btn_16", [[0, "control-rack", {
    "publicAPI": [16],
    "playerStatus": [32],
    "isClientAdvertising": [32],
    "isMediaLoading": [32]
  }], [0, "end-card-overlay", {
    "publicAPI": [16],
    "playerStatus": [32]
  }], [0, "info-overlay", {
    "mediaData": [16]
  }], [0, "ready-overlay", {
    "publicAPI": [16],
    "playerStatus": [32],
    "isMediaLoading": [32],
    "isLiveNow": [32]
  }, [[0, "click", "handleClick"], [0, "keydown", "handleKeyDown"]], {
    "publicAPI": ["onMediaDataChange"]
  }], [0, "indicator-overlay", {
    "publicAPI": [16],
    "indicatorType": [32]
  }], [0, "loading-overlay", {
    "playerStatus": [1, "player-status"]
  }], [0, "share-overlay", {
    "publicAPI": [16],
    "linkDialogVisible": [32],
    "embedDialogVisible": [32],
    "isVisible": [32]
  }, [[0, "focusin", "onFocusIn"], [0, "keydown", "handleKeyDown"], [0, "click", "handleClick"]]], [0, "upcominglive-overlay", {
    "publicAPI": [16],
    "shouldShow": [32],
    "isLiveMedia": [32],
    "upcomingLiveStatus": [32],
    "countDownMessage": [32],
    "countDownLabel": [32],
    "errorMessage": [32]
  }, null, {
    "publicAPI": ["WatchMediaDataChange"]
  }], [0, "options-menu-btn", {
    "publicAPI": [16],
    "menuIsOpen": [32],
    "isTextTrackShowing": [32],
    "audioTrackMenuItems": [32],
    "textTrackMenuItems": [32],
    "currentSubMenu": [32],
    "lastSelectedItemId": [32]
  }, [[0, "click", "handleClick"], [0, "keydown", "handleKeyDown"]], {
    "isTextTrackShowing": ["isTextTrackShowingHandler"]
  }], [0, "recommendations-card", {
    "publicAPI": [16],
    "playerStatus": [1, "player-status"],
    "recommendations": [32],
    "isVisible": [32],
    "maybePlayNext": [32],
    "playNextEnabled": [32],
    "playNextCountdown": [32]
  }, [[0, "keydown", "handleKeyDown"], [0, "click", "handleClick"], [0, "change", "handleChange"]]], [0, "captions-btn", {
    "publicAPI": [16],
    "hasCaptions": [32],
    "captionsOn": [32]
  }, [[0, "click", "handleClick"]]], [0, "error-overlay", {
    "publicAPI": [16],
    "error": [32],
    "liveStreamError": [32]
  }], [0, "fullscreen-btn", {
    "publicAPI": [16]
  }, [[0, "click", "handleClick"]]], [0, "gotolive-btn", {
    "publicAPI": [16],
    "isSeekable": [32],
    "duration": [32],
    "isAtLiveEdge": [32],
    "liveSyncPosition": [32]
  }, [[0, "click", "handleClick"]]], [0, "livelabel-metadata", {
    "publicAPI": [16],
    "isSeekable": [32],
    "duration": [32],
    "isAtLiveEdge": [32]
  }], [0, "share-btn", {
    "publicAPI": [16],
    "playerStatus": [32],
    "shouldHaveFocus": [32]
  }, [[0, "click", "handleClick"]]]]], ["ad-ui-overlay_3", [[0, "video-ui", {
    "publicAPI": [16],
    "containerNode": [16],
    "playerStatus": [32],
    "isUserActive": [32],
    "sizeClass": [32]
  }, [[0, "fullscreenBtnClicked", "onFullscreenBtnClick"]], {
    "publicAPI": ["watchPropHandler"]
  }], [0, "audio-ui", {
    "publicAPI": [16],
    "showName": [32],
    "chapterThumbnail": [32],
    "isClientSideAdvertising": [32]
  }, null, {
    "publicAPI": ["WatchpublicApiChange"]
  }], [0, "ad-ui-overlay", {
    "publicAPI": [16],
    "playerStatus": [32],
    "isAdShowing": [32],
    "isClientSideAdvertising": [32],
    "adInfo": [32],
    "adCurrentTime": [32]
  }]]], ["phoenix-player", [[0, "phoenix-player", {
    "config": [16],
    "mediaData": [16],
    "settings": [16],
    "version": [1537],
    "playerStatus": [32],
    "publicAPI": [32],
    "isInitialized": [32],
    "isAdvertising": [32],
    "sizeConfig": [32],
    "width": [32],
    "height": [32],
    "mediaAspectRatio": [32],
    "containerWidth": [32],
    "containerHeight": [32],
    "play": [64],
    "load": [64],
    "unload": [64],
    "stop": [64],
    "setAdsInactive": [64],
    "updateSizeConfig": [64],
    "updateControlsConfig": [64],
    "destroy": [64]
  }, null, {
    "mediaData": ["WatchMediaDataChange"],
    "isInitialized": ["WatchIsInitializedChange"],
    "version": ["WatchVersionChange"]
  }]]]], options);
};
export { defineCustomElements };